<script>
import useConfiguration from "@/use/Configuration";
import {onMounted} from "vue";
import useSharedSelectData from "@/use/SharedSelectData";
import {useSecurityStore} from "@/stores/Security";
import StrTemplateAutocomplete from "@/views/Edms/Template/Components/StrTemplateAutocomplete.vue";

export default {
    components: {StrTemplateAutocomplete},
    setup() {
        const {modesIrg, profiles, itemsPerPageList, backgroundColor} = useSharedSelectData();
        const {loading, configurations, findAll, save} = useConfiguration();
        
        const securityStore = useSecurityStore();
        
        onMounted(() => findAll());
        
        return {
            securityStore,
            modesIrg,
            profiles,
            itemsPerPageList,
            backgroundColor,
            loading,
            configurations,
            save,
        }
    }
};
</script>

<template>
    <w-app :title="$t('module.configuration')">
        <template #rightToolbar>
            <w-btn-apply
                :show="securityStore.authorities['UPDATE_ADMIN_PARAM']"
                :loading="loading"
                @press="save"
            />
        </template>
        
        <template #content>
            <v-tabs
                dense
                height="35"
                color="teal"
                :background-color="backgroundColor"
            >
                <v-tab>{{ $t('module.worker') }}</v-tab>
                <v-tab>{{ $t('module.contrat') }}</v-tab>
                
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="4">
                                <w-label :label="$t('worker.default_init_state')"/>
                                <w-data-select-autocomplete
                                    v-model="configurations[96].longg"
                                    type="WORKER_STATE"
                                />
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('worker.default_final_state')"/>
                                <w-data-select-autocomplete
                                    v-model="configurations[108].longg"
                                    type="WORKER_STATE"
                                />
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('worker.default_cnas_agency')"/>
                                <str-cnas-agcency-autocomplete
                                    v-model="configurations[126].longg"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('worker.default_irg')"/>
                                <w-enum-select
                                    v-model="configurations[74].strr"
                                    :items="modesIrg"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('worker.default_profile')"/>
                                <w-enum-select
                                    v-model="configurations[75].strr"
                                    :items="profiles"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('worker.default_iep')"/>
                                <w-text-field
                                    v-model="configurations[76].intt"
                                    type="number"
                                />
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('worker.default_rung')"/>
                                <w-text-field
                                    v-model="configurations[77].intt"
                                    type="number"
                                />
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('worker.default_rows_per_page')"/>
                                <w-enum-select
                                    v-model="configurations[78].intt"
                                    :items="itemsPerPageList"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox
                                    v-model="configurations[81].booll"
                                    color="orange"
                                    class="mt-6"
                                    hide-details
                                >
                                    <template v-slot:label>
                                        <strong>{{ $t('worker.import_pay_section') }}</strong>
                                    </template>
                                </v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox
                                    v-model="configurations[79].booll"
                                    color="red"
                                    hide-details
                                >
                                    <template v-slot:label>
                                        <strong>{{ $t('worker.out_of_grille') }}</strong>
                                    </template>
                                </v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox
                                    v-model="configurations[80].booll"
                                    color="teal"
                                    hide-details
                                >
                                    <template v-slot:label>
                                        <strong>{{ $t('worker.pay_active') }}</strong>
                                    </template>
                                </v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox
                                    v-model="configurations[82].booll"
                                    hide-details
                                >
                                    <template v-slot:label>
                                        <strong>{{ $t('worker.show_photo') }}</strong>
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="4">
                                <w-label :label="$t('contrat.default_trial_period_validated_document')"/>
                                <str-template-autocomplete
                                    v-model="configurations[162].longg"
                                    type="CONTENT"
                                    module="CONTRAT"
                                />
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('contrat.default_trial_period_terminated_document')"/>
                                <str-template-autocomplete
                                    v-model="configurations[163].longg"
                                    type="CONTENT"
                                    module="CONTRAT"
                                />
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('contrat.default_trial_period_renewed_document')"/>
                                <str-template-autocomplete
                                    v-model="configurations[164].longg"
                                    type="CONTENT"
                                    module="CONTRAT"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox
                                    v-model="configurations[89].booll"
                                    hide-details
                                >
                                    <template v-slot:label>
                                        <strong>{{ $t('contrat.activate_trial_period_when_renewed') }}</strong>
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
            </v-tabs>
        </template>
    </w-app>
</template>